import React from 'react';

import PropTypes from 'prop-types';
import { dateOnlySlashesFormat, formatUtcDate } from 'App/services/DateService';
import { formatPhone } from 'App/utils';
import { appealReferralDetailsPropType } from './types';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const OverturnedReviewContent = ({ appealReferralDetails, status, appealDocs }) => {
    return (
        <div>
            <ReviewSectionStyle>
                <strong>Referral Details (Appeals)</strong>
                <div>Status: {status}</div>
                <div>Upheld Prior Authorization to Appeal: {appealReferralDetails.paActivityId?.label || '--'} </div>
                <div>
                    Documents for appeals submission:
                    <ul>
                        {appealDocs?.map((doc) => (
                            <li>{doc}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    Appeal Submission Date:
                    {formatUtcDate({
                        date: appealReferralDetails.appealDate,
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>
                <div>PA Number: {appealReferralDetails.paNumber || '--'}</div>
                <div>PA Follow Up Phone Number: {formatPhone(appealReferralDetails.followUpPhone) || '--'}</div>
                <div>
                    Effective Start and End Date:{' '}
                    {formatUtcDate({ date: appealReferralDetails.effectiveStartDate, format: dateOnlySlashesFormat }) ||
                        '--'}
                    -{' '}
                    {formatUtcDate({ date: appealReferralDetails.effectiveEndDate, format: dateOnlySlashesFormat }) ||
                        '--'}
                </div>
                <div>How was approval received? {appealReferralDetails.methodApprovalReceived?.label || '--'}</div>
            </ReviewSectionStyle>
            <ReviewSectionStyle>
                <strong>Notes</strong>
                <div>{appealReferralDetails.notes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

OverturnedReviewContent.propTypes = {
    status: PropTypes.string.isRequired,
    appealReferralDetails: appealReferralDetailsPropType.isRequired,
    appealDocs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OverturnedReviewContent;
